import { render, staticRenderFns } from "./PengajuanKonsultasi.vue?vue&type=template&id=6293e6dc"
import script from "./PengajuanKonsultasi.vue?vue&type=script&lang=js"
export * from "./PengajuanKonsultasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports